import {Flex, FlexItem, Form} from "@patternfly/react-core";

import {testMarks} from "app/view/dataTest";
import {Checkbox, FormGroup, SelectSimple, TaskLibStep} from "app/view/share";

import {useTask} from "./useTask";

const {resourceMove: task} = testMarks.task;

export const Node = () => {
  const {
    updateState,
    isNodeSettingConsistent,
    state: {
      useNode,
      node,
      nodeNameList,
      showValidationErrors,
      libCall: {reports},
    },
  } = useTask();
  return (
    <TaskLibStep title="Destination node" reports={reports} {...task.node.mark}>
      <Form>
        <Flex>
          <FlexItem>
            <Checkbox
              label="Specify destination node"
              aria-label="Specify destination node"
              id="settings-specify-node"
              isChecked={useNode}
              onChange={(checked: boolean) => updateState({useNode: checked})}
              {...task.node.useNode.mark}
            />
          </FlexItem>
          {useNode && (
            <FlexItem>
              <FormGroup
                fieldId="settings-node"
                showValidationErrors={showValidationErrors}
                isValid={isNodeSettingConsistent}
                helperTextInvalid="Please select a node"
              >
                <SelectSimple
                  id="node-to-move"
                  selected={node.length > 0 ? node : undefined}
                  placeholderText="Select a node"
                  offeredOptions={nodeNameList}
                  onSelect={value => updateState({node: value.toString()})}
                  {...task.node.nodeList.mark}
                />
              </FormGroup>
            </FlexItem>
          )}
        </Flex>
      </Form>
    </TaskLibStep>
  );
};
